import React from 'react';
import Hero from './Hero';
import About from './About';
import Products from './Products';
import Subscription from './Subscription';
import Contact from './Contact';
import { Product, User } from '../types';
import B2BVideoCarousel from './B2BVideoCarousel';

interface HomePageProps {
  products: Product[];
  onOpenAddToCartModal: (product: Product) => void;
  isB2BView: boolean;
  user: User | null;
}

const HomePage: React.FC<HomePageProps> = ({ products, onOpenAddToCartModal, isB2BView, user }) => {
  return (
    <>
      <Hero isB2BView={isB2BView} />
      <About />
      {isB2BView && <B2BVideoCarousel />}
      <Products products={products} onOpenAddToCartModal={onOpenAddToCartModal} isB2BView={isB2BView} user={user} />
      {!isB2BView && <Subscription isB2BView={isB2BView} />}
      {!isB2BView && <Contact />}
    </>
  );
};

export default HomePage;